import React from 'react';
import ToggleSwitch from './ToggleSwitch';
import TagInput from './TagInput';

export const DEFAULT_RISK_THRESHOLD = 75;
export const DEFAULT_BLOCKED_GEOS = ['US', 'CN', 'HK', 'IR', 'AS', 'VI', 'GU', 'MH', 'PW', 'PR', 'MP', 'SG'];

export const FILTER_CRITERIA = [
  { key: 'ipBlacklist', label: 'IP blacklist (ISP)' },
  { key: 'geo', label: 'Geo block', tags: { field: 'blockedGeos', label: 'Заблоковані країни', placeholder: 'код країни, Enter', transform: (value) => value.toUpperCase(), defaults: DEFAULT_BLOCKED_GEOS } },
  { key: 'proxyVpn', label: 'Proxy / VPN' },
  { key: 'riskScore', label: 'Trust score', number: { field: 'threshold', label: 'Блокувати при risk ≥', min: 0, max: 100 } },
  { key: 'subIdBlock', label: 'sub_id_1 blocklist' },
  { key: 'refererBlock', label: 'Referer blocklist' },
];

const BASE_PROFILE = {
  ipBlacklist: { enabled: true, providers: [] },
  geo: { enabled: false, blockedGeos: [] },
  proxyVpn: { enabled: false },
  riskScore: { enabled: false, threshold: DEFAULT_RISK_THRESHOLD },
  subIdBlock: { enabled: true },
  refererBlock: { enabled: true },
};

export function buildFilterProfile(source) {
  const profile = {};

  for (const key of Object.keys(BASE_PROFILE)) {
    profile[key] = { ...BASE_PROFILE[key], ...(source?.[key] || {}) };
  }

  return profile;
}

export function buildTrafficFilters(source) {
  return {
    organic: buildFilterProfile(source?.organic),
    nonOrganic: buildFilterProfile(source?.nonOrganic),
  };
}

export function legacyTrafficFilters(app) {
  const profile = {
    ipBlacklist: { enabled: true, providers: [] },
    geo: {
      enabled: !!app?.geoBlock,
      blockedGeos: Array.isArray(app?.blockedGeos) ? app.blockedGeos : [],
    },
    proxyVpn: { enabled: !!app?.proxyCheck },
  };

  return buildTrafficFilters({ organic: profile, nonOrganic: profile });
}

export default function TrafficFilters({ title, subtitle, profile, onChange }) {
  const patch = (key, changes) =>
    onChange({ ...profile, [key]: { ...profile[key], ...changes } });

  return (
    <div className="tf-card">
      <div className="tf-head">
        <div className="tf-title">{title}</div>
        {subtitle ? <div className="tf-rule">{subtitle}</div> : null}
      </div>

      <div className="tf-list">
        {FILTER_CRITERIA.map((criterion) => {
          const state = profile[criterion.key] || {};

          return (
            <div className="tf-row" key={criterion.key}>
              <ToggleSwitch
                label={criterion.label}
                value={!!state.enabled}
                onChange={(enabled) => {
                  const changes = { enabled };

                  if (enabled && criterion.tags?.defaults && !state[criterion.tags.field]?.length) {
                    changes[criterion.tags.field] = criterion.tags.defaults;
                  }

                  patch(criterion.key, changes);
                }}
              />

              {state.enabled && criterion.number ? (
                <div className="tf-extra">
                  <span className="f-label">{criterion.number.label}</span>
                  <input
                    type="number"
                    min={criterion.number.min}
                    max={criterion.number.max}
                    value={state[criterion.number.field] ?? DEFAULT_RISK_THRESHOLD}
                    onChange={(e) => {
                      const raw = Number(e.target.value);
                      const clamped = Math.min(
                        criterion.number.max,
                        Math.max(criterion.number.min, Number.isFinite(raw) ? raw : criterion.number.min)
                      );
                      patch(criterion.key, { [criterion.number.field]: clamped });
                    }}
                    className="f-input tf-number"
                  />
                </div>
              ) : null}

              {state.enabled && criterion.tags ? (
                <div className="tf-extra">
                  <span className="f-label">
                    {criterion.tags.label}
                    <em className="tf-count">{(state[criterion.tags.field] || []).length}</em>
                  </span>
                  <TagInput
                    value={state[criterion.tags.field] || []}
                    onChange={(value) => patch(criterion.key, { [criterion.tags.field]: value })}
                    transform={criterion.tags.transform}
                    placeholder={criterion.tags.placeholder}
                  />
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
}
